import { CountoModule }  from 'angular2-counto';
import { GlobalErrorHandler, LoggerService } from './shared/core/error-handler';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { NgModule, ApplicationRef, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { RouterModule, PreloadAllModules, RouteReuseStrategy } from '@angular/router';

/*
 * Platform and Environment providers/directives/pipes
 */
import { ENV_PROVIDERS } from './environment';
import { ROUTES } from './app.routes';

// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { DashboardComponent } from './dashboard';
import { ProjectModule } from './project/index';
import { ClearanceItemModule } from './clearance-item/clearance-item.module';
import { AddressBookModule } from './address-book/index'
import { AuthService, HttpErrorModel } from './shared/core/index'
import { SharedModule } from './shared/shared.module';
import { AppService } from './app.service'
import { ReactiveFormsModule } from '@angular/forms';
import { ReportsModule } from './reports/reports.module'

import 'jquery/dist/jquery.min.js';
import '../styles/styles.scss';
import '../scripts/custom_sideNav.js';
import { Injector } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserManagementComponent } from './users/user-management.component';
import { UserManagementModule } from './users/user-management.module';
import { SearchModule } from './search/search.module';
import { state } from '@angular/animations';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import { ModalPromptComponent } from './shared/helper-components/modal-prompt.component';
import { CustomReuseStrategy } from './shared/providers/custom-reusestrategy';


import { LoginComponent } from './login/login.component';
import { HttpService } from './shared/core/http.service';
import { AuthenticatedHttpService  } from './shared/core/http.auth.service';
import { ExtendedHttpService  } from './shared/core/http.extended.service';
import { FileUploadModule } from 'ng2-file-upload';
import { PrizmDocViewerWrapperComponent } from './prizmdoc-viewer-wrapper';
import { DocumentService } from './docviewer/document.service';
import { DocumentDetailComponent } from './docviewer/document-detail.component';
import { NavigationTrackerService } from './shared/helper-components/navigation-tracker.service';


// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS
];

type StoreType = {
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

export function startupServiceFactory(authService: AuthService): Function {  
  return () => authService.login()
  .toPromise()
  .catch((err: any) => {
    console.error('startupServiceFactory error :' + err);
    authService.error = err;
    return Observable.throw(err); 
  });;
}



 /**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */

 @NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,    
    DashboardComponent,
    PrizmDocViewerWrapperComponent,
    DocumentDetailComponent
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
    ProjectModule,
    ClearanceItemModule,
    BrowserAnimationsModule,
    AddressBookModule,
    UserManagementModule,
    ReportsModule,
    SearchModule,
    CountoModule,
    FileUploadModule,
    RouterModule.forRoot(ROUTES, { useHash: true, preloadingStrategy: PreloadAllModules })
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    ENV_PROVIDERS,
    APP_PROVIDERS,
    AppService,
    {
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [AuthService],
      multi: true
    },
    LoggerService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    { 
      provide: RouteReuseStrategy, 
      useClass: CustomReuseStrategy 
    },
    HttpService,
    DocumentService,
    NavigationTrackerService
  ]
})
export class AppModule {

  constructor(
    public appRef: ApplicationRef, injector: Injector) {
    AppInjector = injector;
  }

}

export let AppInjector: Injector;



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.module.ts